import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NumberStepperComponent } from './number-stepper.component';

@NgModule({
  declarations: [NumberStepperComponent],
  imports: [CommonModule, FormsModule],
  exports: [NumberStepperComponent],
})
export class NumberStepperModule {}
